import { AsyncThunkAction } from 'actions/actions.types'
import { contactsWithProfile } from 'actions/contactList/function/contactsWithProfile'
import { fetchProfilesApi } from 'api/profile/fetchProfilesApi'

export const UPDATE_CONTACTS_STATUS = 'UPDATE_CONTACTS_STATUS' as const

const updateContactListPlainAction = (contactIds: number[]) => ({
  type: UPDATE_CONTACTS_STATUS,
  promise: () => fetchProfilesApi(contactIds),
})

export const updateContactsStatusAction =
  (): AsyncThunkAction => (dispatch, getState) => {
    const { contactList } = getState()

    if (contactList?.contactList) {
      return dispatch(
        updateContactListPlainAction(
          contactList?.contactList
            .filter(contactsWithProfile)
            .map(({ anketa }) => anketa!.id)
        )
      )
    }

    return Promise.resolve()
  }

export type ContactsUpdateActionTypes = ReturnType<
  typeof updateContactListPlainAction
>
